import React, { useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';

export default function Clipboard({ content, tooltip = 'Copy content' }) {
  const ref = useRef(null);
  
  const handleCopy = () => {
    const textContent = typeof content === 'string' ? content : ref.current?.innerText;
    if (textContent) {
      navigator.clipboard.writeText(textContent);
    }
  };
  
  return (
    <div className="relative bg-white rounded border p-3 my-2">
      <div ref={ref} className="overflow-x-auto text-xs font-mono whitespace-pre pb-2">
        {content}
      </div>
      <div className="absolute top-2 right-2">
        <Tooltip title={tooltip}>
          <IconButton 
            size="small" 
            onClick={handleCopy}
            style={{ 
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }}
            sx={{
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: '#f5f5f5'
              }
            }}
          >
            <FileCopyOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}